import {useEffect, useState} from 'react';

import {resolveStoredJson} from '@/utils';

import {appStorage} from './useStorageManager';

const storeAsIs = (value: unknown): unknown => value;

/**
 * State kept as JSON in `appStorage` under `key` (read once, on mount). `parse` guards what a
 * person or an older build left there; `toStored` returning `undefined` drops the stored copy.
 */
export function useJsonStorage<T>(
  key: string,
  fallback: T,
  parse: (stored: unknown) => T | null,
  toStored: (value: T) => unknown = storeAsIs
) {
  const [value, setValue] = useState(() =>
    resolveStoredJson(appStorage.getJson<unknown>(key), fallback, parse)
  );

  useEffect(() => {
    const stored = toStored(value);
    if (stored === undefined) appStorage.removeItem(key);
    else appStorage.setJson(key, stored);
  }, [key, value, toStored]);

  return [value, setValue] as const;
}
